// extracted by mini-css-extract-plugin
export default {"DropWrapper":"FileDropZone_DropWrapper__aiCcE"};